/*
 * Klaviyo native forms -> n8n consent bridge.
 * Quando un form Klaviyo integrato nel sito viene inviato
 * (evento "klaviyoForms" con type "submit"), inoltra email + consenso tracking
 * allo stesso webhook n8n usato dai form newsletter del tema.
 * Config letta da window.nlConsentConfig (webhook + secret + market), emessa dal tema.
 * text/plain -> nessun preflight CORS (non serve leggere la risposta).
 */
(function () {
  window.addEventListener('klaviyoForms', function (e) {
    if (!e.detail || e.detail.type !== 'submit') return;

    var cfg = window.nlConsentConfig || {};
    if (!cfg.webhook) return;

    var data = e.detail.metaData || {};
    // Klaviyo usa le chiavi con $ per i campi standard ($email, $first_name, ...).
    var email = data['$email'] || data.email || '';
    if (!email) return;

    // Sign-up via form Klaviyo = opt-in al tracking.
    // Se il form Klaviyo ha una checkbox di consenso, mappa qui il suo valore.
    var trackingConsent = true;

    var payload = {
      email: email,
      trackingConsent: trackingConsent,
      market: cfg.market || '',
      source: 'klaviyo-form',
      formId: e.detail.formId,
      secret: cfg.secret || ''
    };

    var body = JSON.stringify(payload);
    try {
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: 'text/plain;charset=UTF-8' });
        if (navigator.sendBeacon(cfg.webhook, blob)) return;
      }
    } catch (err) {}
    try {
      fetch(cfg.webhook, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: body,
        keepalive: true
      }).catch(function () {});
    } catch (err) {}
  });
})();
